import React, { useState } from "react";
import { toast } from "sonner";
import { Btn, Field, inputCls } from "./dash/Kit";
import { api, errMessage } from "../lib/api";
import { useAuth } from "../lib/AuthContext";

/** Google sign-ups arrive without a business name — ask for it before anything else. */
export default function BusinessNamePrompt() {
  const { user, refresh } = useAuth();
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (!user || user.role === "admin" || (user.business_name || "").trim()) return null;

  const save = async () => {
    if (name.trim().length < 2) {
      setError("Please enter your business name.");
      return;
    }
    setError("");
    setBusy(true);
    try {
      await api.put("/me", { business_name: name.trim(), phone: phone.trim() });
      toast.success("Thanks — that's all we need for now.");
      await refresh();
    } catch (e) {
      setError(errMessage(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[70] flex items-end justify-center bg-slate-900/50 p-4 sm:items-center" role="dialog" aria-label="Business name">
      <div className="w-full max-w-md rounded-3xl bg-white p-6 sm:p-8" data-testid="business-name-prompt">
        <h2 className="font-display text-2xl font-bold text-slate-900">One quick thing</h2>
        <p className="mt-2 text-sm leading-relaxed text-slate-600">
          Welcome, {user.first_name}. What's the name of your business? We use it on every post and caption we create for
          you.
        </p>

        <div className="mt-6 space-y-5">
          <Field label="Business name *" error={error} htmlFor="prompt-business-name">
            <input
              id="prompt-business-name"
              data-testid="prompt-business-name-input"
              className={inputCls}
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Trattoria Rotterdam"
              autoFocus
            />
          </Field>
          <Field label="Phone number (optional)" htmlFor="prompt-phone">
            <input id="prompt-phone" data-testid="prompt-phone-input" className={inputCls} value={phone} onChange={(e) => setPhone(e.target.value)} />
          </Field>
        </div>

        <Btn testId="prompt-business-name-save" className="mt-6 w-full" onClick={save} disabled={busy}>
          {busy ? "Saving…" : "Continue"}
        </Btn>
      </div>
    </div>
  );
}
